import Box from '@mui/material/Box';

interface LogoProps {
  width?: number | string;
  height?: number | string;
  maxWidth?: number | string;
  mode?: 'light' | 'dark';
}

function Logo({ width, height, maxWidth, mode }: LogoProps) {
  return (
    <Box
      component="img"
      src={mode === 'dark' ? "/logo/Halo_Studio_white.svg" : "/logo/Halo_Studio.svg"}
      alt="Halo Studio Logo"
      sx={{ objectFit: 'contain', width, height, maxWidth }}
    />
  );
}

export default Logo;
